import React from "react";

import styles from "./CardLayout.module.scss";

const CardLayout = ({ children = null }) => (
  <div className={styles.base}>{children}</div>
);

export default CardLayout;
